export default "__VITE_ASSET__DErcZizI__"